import React from 'react'
import { FormFieldInterface } from 'src/shared/types/entities/form-interface'
import { BasePublisherPhoneNumberField } from '../../base-publisher-field/base-publisher-phone-number-field'
import { useFormField } from '../hooks/use-form-field'

interface FormPhoneNumberFieldSubentityProps {
  fieldSubentity: FormFieldInterface
}

export const FormPhoneNumberFieldSubentity = ({
  fieldSubentity,
}: FormPhoneNumberFieldSubentityProps) => {
  const { value, onChange, errors } = useFormField({
    fieldSubentity,
  })
  return (
    <BasePublisherPhoneNumberField
      entity={fieldSubentity}
      value={value}
      onChange={onChange}
      errors={errors}
    />
  )
}
